import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Footer from 'components/Footer/Footer'
import styles from 'assets/jss/material-kit-react/views/landingPage'

import CheckForWallet from 'components/nft/CheckForWallet'
import classNames from 'classnames'

import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { getETHRate } from 'eth/ethUtils'
import Card from 'components/Card/Card'
import Purchase from 'components/nft/Purchase'
import HarmonizeHeader from 'components/Header/HarmonizeHeader'

const useStyles = makeStyles(styles)
export default function PurchaseToken() {
    const { currency } = useSelector((state) => state.settings)
    const [eth, setEth] = useState()

    const classes = useStyles()

    useEffect(() => {
        getETHRate(currency).then((rate) => setEth(rate))
    }, [])

    if (eth) {
        return (
            <div>
                <HarmonizeHeader />
                <div
                    className={classNames(classes.main, classes.mainRaised)}
                    style={{ marginTop: 0 }}
                >
                    <Card>
                        <CheckForWallet
                            label='purchase'
                            render={() => {
                                return <Purchase eth={eth} />
                            }}
                        />
                    </Card>
                </div>
                <Footer />
            </div>
        )
    } else {
        return null
    }
}